"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.variant = exports.__css = exports.sx = void 0;
var css_1 = __importStar(require("@styled-system/css"));
exports.sx = function (props) { return css_1.default(props.sx)(props.theme); };
exports.__css = function (props) { return css_1.default(props.__css)(props.theme); };
exports.variant = function (_a) {
    var _b = _a.theme, theme = _b === void 0 ? {} : _b, _c = _a.variant, styledVariant = _c === void 0 ? '' : _c, _d = _a.tx, tx = _d === void 0 ? 'variants' : _d;
    return css_1.default(css_1.get(theme, tx + "." + styledVariant, css_1.get(theme, styledVariant)))(theme);
};
